// import { PCFSoftShadowMap, DirectionalLight, CameraHelper, Vector3, PlaneBufferGeometry, Mesh, MeshStandardMaterial, Color } from 'three'
import { PCFSoftShadowMap, DirectionalLight, CameraHelper, Vector3 } from 'three'
import { EffectNode } from '../../Core/EffectNode'
export class LightShadow extends EffectNode {
  constructor ({ ctx, showHelper = false }) {
    super({ ctx })

    let lightPos = new Vector3(5, 10, 5).multiplyScalar(15)

    ctx.renderer.shadowMap.enabled = true
    ctx.renderer.shadowMap.type = PCFSoftShadowMap

    const light = new DirectionalLight(0xffffff, 0.5)
    light.position.copy(lightPos) //default; light shining from top
    light.castShadow = true // default false
    ctx.scene.add(light)

    //Set up shadow properties for the light
    light.shadow.mapSize.width = 256 // default
    light.shadow.mapSize.height = 256 // default
    light.shadow.camera.near = 0.1 // default
    light.shadow.camera.far = 250 // default
    light.shadow.camera.zoom = 0.2

    this.light = light
    this.lightPos = lightPos

    // const shadowFloorGeometry = new PlaneBufferGeometry(5000, 5000, 2, 2 );
    // // const shadowFloorMaterial = new ShadowMaterial({ opacity: 0.7 })
    // const shadowFloorMaterial = new MeshStandardMaterial({ color: new Color('#323232').offsetHSL(0, 0, 0.3), transparent: true, opacity: 0.0 })
    // const shadowFloor = new Mesh( shadowFloorGeometry, shadowFloorMaterial );
    // shadowFloor.receiveShadow = true;
    // shadowFloor.rotation.x = Math.PI * -0.5
    // // shadowFloor.position.y += 0.03
    // // shadowFloor.position.y += 0
    // ctx.scene.add( shadowFloor );

    if (showHelper) {
      //Create a helper for the shadow camera (optional)
      const helper = new CameraHelper(light.shadow.camera)
      ctx.scene.add(helper)
    }

    // ctx.onLoop(() => {
    //   tracker.getWorldPosition(light.position)
    //   light.position.add(lightPos)
    //   tracker.getWorldPosition(light.target.position)
    //   light.target.lookAt(tracker.position)
    // })
  }
}
